export default "__VITE_ASSET__B5IDPwN7__"